import { animateScroll as scroll } from 'react-scroll'
import 'rodal/lib/rodal.css';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { propTypes, reduxForm } from 'redux-form';
import React from 'react';
import styled from 'react-emotion';
import { withFirestore } from 'react-redux-firebase';

import { deleteActiveEvent, updateActiveEvent } from '../../../../redux/actions/events';
import EventForm from '../../../../components/Form/EventForm/EventForm';
import { FORM_NAME } from './constants';
import ManageEventsBodyFormFooter from './ManageEventsBodyFormFooter/ManageEventsBodyFormFooter';
import { submitReset } from '../../../../redux/actions/submit';
import SuccessModal from '../../../../components/Modals/SuccessModal/SuccessModal';
import Style from '../../../../styles/common';

const Container = styled('div')`
  display: inline-block;
  padding: 80px ${Style.SPACING.L} ${Style.MEASUREMENT.EVENT_FORM.PADDING_BOTTOM};
`;

const filesPath = 'posters';

class ManageEventsBodyForm extends React.Component {
  static propTypes = {
    ...propTypes,
    authUser: PropTypes.object,
    eventTitle: PropTypes.string,
    hasFailed: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    isSuccessful: PropTypes.bool,
    uploadedFiles: PropTypes.arrayOf(PropTypes.object),
  };

  static defaultProps = {
    authUser: null,
    eventTitle: '',
    hasFailed: false,
    isSubmitting: false,
    isSuccessful: false,
    uploadedFiles: [],
  };

  render() {
    return (
      <Container>
        <EventForm
          formName={FORM_NAME}
          onSubmit={this.props.handleSubmit(this.props.updateActiveEvent)}
        >
          <ManageEventsBodyFormFooter
            eventTitle={this.props.eventTitle}
            deleteActiveEvent={this.props.deleteActiveEvent}
            hasFailed={this.props.hasFailed}
            isSubmitting={this.props.isSubmitting}
            isSuccessful={this.props.isSuccessful}
            submitFailed={this.props.submitFailed}
          />
        </EventForm>
        <SuccessModal
          continueText="Continue updating"
          eventId={this.props.lastSavedEventId}
          onClose={this.onModalClose}
          title="Your event has been updated!"
          visible={this.props.isSuccessful}
        />
      </Container>
    );
  }

  onModalClose = () => {
    this.props.reset();
    this.props.submitReset();
    scroll.scrollToTop({ duration: 500 });
  };
}

export default compose(
  reduxForm({
    form: FORM_NAME,
    enableReinitialize: true,
  }),
  withFirestore,
  connect(
    state => ({
      authUser: state.firebase.auth,
      hasFailed: state.submit.hasFailed,
      isSubmitting: state.submit.isRequesting,
      isSuccessful: state.submit.isSuccessful,
      lastSavedEventId: state.lastSavedEventId,
      uploadedFiles: state.firebase.data[filesPath] || [],
    }),
    { deleteActiveEvent, submitReset, updateActiveEvent },
  ),
)(ManageEventsBodyForm);



// WEBPACK FOOTER //
// ./src/views/ManageEvents/ManageEventsBody/ManageEventsBodyForm/ManageEventsBodyForm.js